module.exports = __webpack_public_path__ + "img/uk-genitourinary-diseases-female.d068a9d8.png";